import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type Props = {
  open: boolean;
  heatName: string | null;
  onShip: () => void;
  onDismiss: () => void;
};

export const ShipAlertModal = ({
  open,
  heatName,
  onShip,
  onDismiss,
}: Props) => {
  return (
    <Dialog maxWidth="xs" open={open}>
      <DialogTitle>Ship Signal Detected</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          A ship signal has been detected for heat{" "}
          <strong>{heatName ?? "unknown"}</strong>. Do you want to ship this
          process now?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss}>Dismiss</Button>
        <Button onClick={onShip} variant="contained" color="primary">
          Ship
        </Button>
      </DialogActions>
    </Dialog>
  );
};
